const registeredCleanups: Array<() => void> = [];

export { registeredCleanups };
